document.addEventListener("DOMContentLoaded", function () {
  const popupBtn = document.querySelector(".banner-pop-btn");
  const popup = document.querySelector(".banner-popup-content");
  const overlay = document.querySelector(".light-d-overlay");
  const closeBtn = document.querySelector(".close-btn");

  function openPopup() {
    popup.classList.remove("closing");
    popup.classList.add("open");
    document.body.classList.add("js-popup-open");
  }

  function closePopup() {
    popup.classList.add("closing");
    popup.classList.remove("open");
    document.body.classList.remove("js-popup-open");

    setTimeout(() => {
      popup.classList.remove("closing");
    }, 400);
  }

  if (popupBtn) popupBtn.addEventListener("click", openPopup);
  if (closeBtn) closeBtn.addEventListener("click", closePopup);
  if (overlay) overlay.addEventListener("click", closePopup);
});

// COLLECTION SLIDER SCRIPT START
$(".cstm-collection-slides").slick({
  centerMode: true,
  centerPadding: "0px",
  dots: false,
  arrows: true,
  infinite: true,
  speed: 300,
  slidesToShow: 5,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1180,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: true,
      },
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
});
// Arrow navigation
$(".eg-shapes-slider-nav-button.prev").on("click", function () {
  $(".cstm-collection-slides").slick("slickPrev");
});
$(".eg-shapes-slider-nav-button.next").on("click", function () {
  $(".cstm-collection-slides").slick("slickNext");
});
// CHANGE TEXT ON THE SPOT
function updateSliderContent($slider) {
  const wrapper = $slider.closest(".collection-list-slider");
  const $centerSlide = $slider.find(".slick-current.slick-active.slick-center");

  if ($centerSlide.length) {
    const newTitle = $centerSlide.find("h4.text-center").text().trim();
    const newDesc = $centerSlide.find(".cstm-rte").html().trim();

    const $dynamicArea = wrapper.find(".ccs-content-main .ccs-content");
    const $title = $dynamicArea.find("h4.text-center");
    const $desc = $dynamicArea.find(".cstm-rte");

    $title.fadeOut(150, function () {
      $(this).text(newTitle).fadeIn(150);
    });

    $desc.fadeOut(150, function () {
      $(this).html(newDesc).fadeIn(150);
    });
  }
}

$(".cstm-collection-slides-shape").on("init reInit afterChange", function() { updateSliderContent($(this)); });
$(".cstm-collection-slides-styles").on("init reInit afterChange", function() { updateSliderContent($(this)); });

// Trigger once on load (in case Slick fires late)
setTimeout(updateSliderContent($(".cstm-collection-slides-shape")), 200);
setTimeout(updateSliderContent($(".cstm-collection-slides-styles")), 200);

// REVIEW SLIDER SCRIPT START
$(".cstm-review-slides").slick({
  dots: true,
  arrows: false,
  infinite: true,
  speed: 300,
  slidesToShow: 5,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1280,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
});

// ARTICLE CARD SLIDER SCRIPT START
$(".cstm-blog-slider").slick({
  dots: false,
  arrows: false,
  infinite: true,
  speed: 300,
  centerMode: true,
  // Tạo cảm giác overflow: chỉ 3.75-4.25 cards nhìn thấy
  centerPadding: "70px",
  slidesToShow: 4,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1080,
      settings: {
        centerMode: true,
        centerPadding: "50px",
        slidesToShow: 3,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: true,
        centerPadding: "22px",
      },
    },
  ],
});
$(".csmt-blog-section .section-header-slick-arrow .prev").click(function () {
  $(this).closest('.csmt-blog-section').find('.cstm-blog-slider').slick("slickPrev");
});
$(".csmt-blog-section .section-header-slick-arrow .next").click(function () {
  $(this).closest('.csmt-blog-section').find('.cstm-blog-slider').slick("slickNext");
});

// FEATURD COLLECTION PRODUCT SLIDER SCRIPT START
$(".feature-collection-prd-slider").slick({
  dots: false,
  arrows: false,
  infinite: true,
  speed: 300,
  slidesToShow: 5,
  slidesToScroll: 1,
  draggable: false,
  swipe: false,
  touchMove: false,
  responsive: [
    {
      breakpoint: 1080,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1,
        draggable: false,
        swipe: false,
        touchMove: false,
      },
    },
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        draggable: false,
        swipe: false,
        touchMove: false,
      },
    },
    {
      breakpoint: 480,
      settings: {
        centerMode: true,
        centerPadding: "40px",
        slidesToShow: 1,
        slidesToScroll: 1,
        draggable: false,
        swipe: false,
        touchMove: false,
      },
    },
  ],
});

$(".cstm-feature-collection .cstm-section-header .prev").click(function () {
  $(this).closest('.cstm-feature-collection').find('.feature-collection-prd-slider').slick("slickPrev");
});
$(".cstm-feature-collection .cstm-section-header .next").click(function () {
  $(this).closest('.cstm-feature-collection').find('.feature-collection-prd-slider').slick("slickNext");
});

// MOBILE MENU DRAWER CSS START
const hamburgerMenu = document.querySelector(".hamburger-menu");
const mobileMenu = document.querySelector(".mobile-menu-drawer");
const overlayDrawer = document.querySelector(".light-d-overlay");
const closeDrawer = document.querySelector(".close-drawer");

function openPopup() {
  mobileMenu.classList.remove("closing");
  mobileMenu.classList.add("open");
  document.body.classList.add("js-popup-open");
}

function closePopup() {
  mobileMenu.classList.add("closing");
  mobileMenu.classList.remove("open");
  document.body.classList.remove("js-popup-open");

  setTimeout(() => {
    mobileMenu.classList.remove("closing");
  }, 400);
}

if (hamburgerMenu) hamburgerMenu.addEventListener("click", openPopup);
if (closeDrawer) closeDrawer.addEventListener("click", closePopup);
if (overlayDrawer) overlayDrawer.addEventListener("click", closePopup);

// MOBILE MEGA MENU COLLASIPLE
$(document).ready(function () {
  if (window.innerWidth <= 991) {
    $(".cstm-mega-main").on("click", function () {
      $(this).parent(".cstm-menu-item").toggleClass("cstm-menu-item-open");

      $(this).next(".cstm-mega-menu-grid").slideToggle();

      $(".cstm-mega-main").not(this).next(".cstm-mega-menu-grid").slideUp();
      $(".cstm-menu-item")
        .not($(this).parent(".cstm-menu-item"))
        .removeClass("cstm-menu-item-open");
    });
  }
});
$("#product-grid .grid__item").hover(
  function () {
    $(this).addClass("grid-item-hovered");
  },
  function () {
    $(this).removeClass("grid-item-hovered");
  }
);
